export type AppLanguage = 'en' | 'zh';

interface ResolveLocaleInput {
  stored?: string | null;
  navigator?: string | null;
}

// resolveLocale enforces persisted user preference first, then browser language,
// and finally falls back to English.
export function resolveLocale(input: ResolveLocaleInput): AppLanguage {
  const stored = normalize(input.stored);
  if (stored) return stored;

  const nav = normalize(input.navigator);
  if (nav) return nav;

  return 'en';
}

function normalize(value?: string | null): AppLanguage | null {
  if (!value) return null;
  const v = value.toLowerCase();
  if (v.startsWith('zh')) return 'zh';
  if (v.startsWith('en')) return 'en';
  return null;
}
